export * from './proprietario-cadastro.dto';
